import { defineMessages } from 'react-intl'

export default defineMessages({
  skipAd: {
    id: 'app.video.AdSkipControl.skipAd',
    defaultMessage: 'Skip ad',
  },
  skipAdIn: {
    id: 'app.video.AdSkipControl.skipAdIn',
    defaultMessage: 'Skip this ad in',
  },
  skipAdInSeconds: {
    id: 'app.video.AdSkipControl.skipAdInSeconds',
    defaultMessage: '{skipIn, number} second{skipIn, plural, one {} other {s}}',
  },
  playAfterAd: {
    id: 'app.video.AdSkipControl.playAfterAd',
    defaultMessage: 'Your movie will play after this ad',
  },
})
